import React from 'react';
import './About.css';

export default function About() {
  return (
    <div className="about-page">

      <section className="about__hero">
        <p className="section-label">Our story</p>
        <h1 className="section-heading">A studio rooted in community</h1>
        <p className="about__hero-sub">
          Flourish Yoga was born from a simple belief: that yoga should be accessible,
          intelligent and deeply human. We're a new studio in St. Petersburg, Florida,
          bringing together a community of teachers and students who share a love of
          movement, breath and stillness.
        </p>
      </section>

      <section className="about__story">
        <div className="about__story-block">
          <div className="about__story-text">
            <p className="section-label">Iyengar yoga</p>
            <h2 className="section-heading">Precision, props & possibility</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
              culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
          <div className="about__story-accent about__story-accent--coral" />
        </div>

        <div className="about__story-block about__story-block--alt">
          <div className="about__story-accent about__story-accent--sage" />
          <div className="about__story-text">
            <p className="section-label">Hatha & vinyasa</p>
            <h2 className="section-heading">Strength, flow & breath</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
              culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
        </div>

        <div className="about__story-block">
          <div className="about__story-text">
            <p className="section-label">Flow, restorative & meditation</p>
            <h2 className="section-heading">Move, rest & be still</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
              fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
              culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </div>
          <div className="about__story-accent about__story-accent--coral" />
        </div>
      </section>

      <section className="about__values">
        <p className="section-label">What we believe</p>
        <h2 className="section-heading">Our values</h2>
        <div className="about__values-grid">
          <div className="about__value-item">
            <h3>Welcoming</h3>
            <p>Every body, every level, every background. You belong here from your very first class.</p>
          </div>
          <div className="about__value-item">
            <h3>Intelligent</h3>
            <p>We teach with care and precision. Understanding why matters as much as what.</p>
          </div>
          <div className="about__value-item">
            <h3>Community</h3>
            <p>Yoga is better together. We're building something that lasts beyond the mat.</p>
          </div>
          <div className="about__value-item">
            <h3>Accessible</h3>
            <p>Props, modifications, options — we meet you where you are and help you grow.</p>
          </div>
        </div>
      </section>

      <section className="about__location">
        <p className="section-label">Find us</p>
        <h2 className="section-heading">St. Petersburg, Florida</h2>
        <p className="about__location-text">
          We're located in the Tyrone area of St. Pete — more details on our exact address coming soon.
          Stay tuned for our opening date announcement.
        </p>
      </section>

    </div>
  );
}
